import React, { useState } from "react";
import { Modal, FormGroup } from "react-bootstrap";
import OutlineButton from "../ui/outline-button/OutlineButton";
import BarLoader from "react-spinners/BarLoader";

interface IProps {
  children: {
    headerText: string;
    bodyText: import("react").ReactNode;
    confirmButtonText: string;
    confirmButtonColor:
      | "green"
      | "red"
      | "blue"
      | "light-blue"
      | "yellow"
      | "gray"
      | "grayStatic";
    cancelButtonText: string;
  };
  show: boolean;
  showConfirmInput?: boolean;
  showConfirmInputText?: string;
  loading: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

const ConfirmationModal = ({
  children,
  show,
  loading,
  onCancel,
  onConfirm,
  showConfirmInput = false,
  showConfirmInputText = "",
}: IProps) => {
  const [confirmState, setConfirmState] = useState({
    disabled: showConfirmInput,
    text: "",
  });

  const onClickCancel = () => {
    onCancel();
  };

  const onClickConfirm = () => {
    onConfirm();
  };

  return (
    <div>
      <Modal centered show={show} className="p-3">
        <Modal.Body className="p-0">
          <FormGroup
            className="px-4 py-3"
            style={{
              fontSize: "18px",
              fontWeight: "bold",
              paddingBottom: "20px",
              backgroundColor: "#006699",
              color: "#fff",
              letterSpacing: "1.5px",
            }}
          >
            {children.headerText}
          </FormGroup>
          {loading && (
            <BarLoader
              height={4}
              width={"100%"}
              color={"#006699"}
              loading={loading}
            />
          )}
          <div className="px-4 py-3">
            <FormGroup>{children.bodyText}</FormGroup>
            {showConfirmInput && (
              <FormGroup>
                <label style={{ color: "#505050", fontWeight: "bold" }}>
                  Type '{showConfirmInputText}' in capital letters to confirm:
                </label>
                <input
                  className="app-input"
                  placeholder={showConfirmInputText}
                  disabled={!confirmState.disabled}
                  value={confirmState.text}
                  onChange={(e) => {
                    setConfirmState({
                      ...confirmState,
                      text: e.target.value,
                      disabled: e.target.value !== showConfirmInputText,
                    });
                  }}
                />
              </FormGroup>
            )}
            <FormGroup className="text-right pt-4">
              <OutlineButton color={"gray"} onClick={onClickCancel}>
                {children.cancelButtonText}
              </OutlineButton>
              <span className="p-2"></span>
              <OutlineButton
                color={children.confirmButtonColor}
                disabled={loading || confirmState.disabled}
                onClick={() => {
                  !loading && !confirmState.disabled && onClickConfirm();
                }}
              >
                {children.confirmButtonText}
              </OutlineButton>
            </FormGroup>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default ConfirmationModal;
